import NoticeManage from './notice_manage.vue';

export default NoticeManage;
